import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { Spinner } from '../../../../common/index.jsx';
import { useGetIngProjectQuery } from '../../../../../redux/services/ing_projects.jsx';
import IngProjectsDetail from '../../../../common/IngProjects/IngProjectsDetail.jsx';


const IngProjectsDetailPage = () => {
  const { t } = useTranslation();
  const { projectId } = useParams();

  const { data: project, isLoading: isLoadingProject } =
    useGetIngProjectQuery(projectId);

  useEffect(() => {
    document.title = t('Detail inžinierskeho projektu') + ' | FRI UNIZA';
  }, [t]);

  return (
    <>
      <AppBarCMS
        title={t('Detail projektu inž. štúdia')}
        backUrl={-1}
        backUrlTooltip={t('Späť')}
      />

      {isLoadingProject ? <Spinner /> : <IngProjectsDetail project={project} />}
    </>
  );
};

export default IngProjectsDetailPage;
